import React from 'react';
import {TopBar} from './componentes/top-bar/top-bar';
import {SideMenu} from './componentes/side-menu/side-menu';
import {AppBarNavigation} from './componentes/app-bar-navigation/app-bar-navigation';
import { MobileMenu } from './componentes/side-menu/mobile-menu';



import Moment from 'react-moment'

import { Layout} from 'antd';

import './App.css';

import '@contentsys/contentsys-react-components/dist/index.css'

import {UserSession} from './componentes/user-session/user-session';
import {BrowserRouter as Router} from 'react-router-dom';

import {getMainMenuRouter} from './routers/router-principal';
import { VerifyDomain } from './componentes/domain-verification/verify-domain';



class App extends React.Component {

  
  render = () => {

    const { Footer, Content} = Layout;
    
    const hoje = new Date();

    return (
      <VerifyDomain>

      
      <UserSession>

        <div className='App'>
          <AppBarNavigation></AppBarNavigation>

          <Router>

            <Layout className="mainLayout">
              
              <MobileMenu></MobileMenu>
              <SideMenu></SideMenu>
              
              <Layout>
                <TopBar></TopBar>   
                <Content className='main'>

                    {getMainMenuRouter()}
                
                </Content>

                <Footer style={{
                    padding: "0",
                    paddingBottom: "15px"
                  }} >Contentsys &copy; <Moment format="YYYY">{hoje}</Moment> - Todos os direitos reservados
                </Footer>

              </Layout>       
            </Layout>
          </Router>
        </div>
      </UserSession>
      </VerifyDomain>
    );
  }
}

export default App;
